import PageCover from "../components/PageCover";
import ContactForm from "../components/ContactForm";
import ContactMap from "../components/ContactMap";
import { Grid, Box, Container } from "@mui/material";
import ContactInfoCard from "../components/ContactInfoCard";
import PinDropOutlinedIcon from "@mui/icons-material/PinDropOutlined";
import MarkEmailUnreadOutlinedIcon from "@mui/icons-material/MarkEmailUnreadOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
// import site_cover from "../assets/site_cover.jpg";
import truck_alone from "../assets/truck_alone.jpg";

const Contact = () => {
  return (
    <>
      <PageCover
        title="Contact Us"
        subtitle="We are here to support your trading & logistics needs."
        breadcrumb="Contact"
        bgImage={truck_alone}
      />

      {/* NO container here */}
      <Box sx={{ width: "100%" }}>
        <Grid container>
          {/* Map */}
          <Grid size={{ xs: 12, md: 4 }}>
            <ContactMap />
          </Grid>

          {/* Form */}
          <Grid size={{ xs: 12, md: 4 }}>
            <ContactForm />
          </Grid>

          {/* Image */}
          <Grid size={{ xs: 12, md: 4 }} sx={{ position: "relative" }}>
            <Box
              className="layerc"
              sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                backgroundColor: "#0000008c",
              }}
            ></Box>
            <Box
              sx={{
                backgroundImage:
                  "url('https://cdn.pixabay.com/photo/2017/06/14/17/31/site-2402789_1280.jpg')",
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100%",
              }}
            ></Box>
          </Grid>
        </Grid>

        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
          <Grid
            container
            spacing={4}
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
              gap: 4,
            }}
          >
            <Grid item xs={12} sm={6} md={4}>
              <ContactInfoCard
                icon={<PinDropOutlinedIcon fontSize="inherit" />}
                title="Office Address"
                info="1/8, Vardan Khand, Sector 1, Gomti Nagar, Lucknow, Uttar Pradesh 226010"
                bgImage="https://cdn.pixabay.com/photo/2019/08/26/06/24/quarry-4430879_1280.jpg"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <ContactInfoCard
                icon={<MarkEmailUnreadOutlinedIcon fontSize="inherit" />}
                title="Email Us"
                info="shankhtrading@gmail.com"
                bgImage="https://cdn.pixabay.com/photo/2016/11/29/04/15/digger-1867268_1280.jpg"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <ContactInfoCard
                icon={<PhoneInTalkOutlinedIcon fontSize="inherit" />}
                title="Call Us"
                info="(+91) 993570193 (+91) 6390902009"
                bgImage="https://cdn.pixabay.com/photo/2017/10/20/12/09/backhoe-2870953_1280.jpg"
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Contact;
